import {
  teamsDarkV2Theme,
  teamsHighContrastTheme,
  teamsV2Theme,
  ThemePrepared,
} from "@fluentui/react-northstar";
import { themeNames } from "@fluentui/react-teams";
import { selector } from "recoil";
import { msTeamsThemeState } from "states/ms-teams";

/**
 * @fluentui/react-northstar 테마
 */
export const rnsThemeState = selector<ThemePrepared>({
  key: "rnsThemeState",
  get: ({ get }) => {
    const theme = get(msTeamsThemeState);

    switch (theme) {
      case "contrast":
        return teamsHighContrastTheme;
      case "dark":
        return teamsDarkV2Theme;
      default:
        return teamsV2Theme;
    }
  },
});

/**
 * @fluentui/react-teams 테마 이름
 */
export const rtThemeNameState = selector<themeNames>({
  key: "rtThemeNameState",
  get: ({ get }) => {
    const theme = get(msTeamsThemeState);

    switch (theme) {
      case "contrast":
        return themeNames.HighContrast;
      case "dark":
        return themeNames.Dark;
      default:
        return themeNames.Default;
    }
  },
});
